import { useEffect } from 'react'
import { LaunchDarkly, Org } from '@truepill/tpos-types'
import { useClient, useFlag } from 'providers/LaunchDarklyProvider'

export default function useCheckCanUseInventory(locationLegacyId?: number, org?: string): boolean {
  const { ldReady, ldIdentify } = useClient()
  // Set the location for feature-flag check
  useEffect(() => {
    if (ldReady && locationLegacyId !== undefined) {
      ldIdentify({
        key: '3',
        custom: {
          locationLegacyId: locationLegacyId.toString(),
        },
      })
    }
  }, [ldReady, ldIdentify, locationLegacyId])

  const locationCanBypassAltoOrgCheck = useFlag(LaunchDarkly.FeatureFlags.BYPASS_ORG_CHECK_FOR_INVENTORY)
  // all truepill pharmacies can use inventory, and some alto/LGC ones depending on what the LD flag returns.
  // no org set is assumed to be truepill as well
  const locationCanUseInventory = !org || org === Org.Truepill || locationCanBypassAltoOrgCheck || false
  return locationCanUseInventory
}
